import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import classnames from "classnames";
// import { jobs } from "../../common/data";
import { useTranslation } from "react-i18next";
import "./styles.less";

export const JoinusJob = (props) => {
  const nav = useNavigate();
  const [selected, setSelected] = useState("all");
  const enterDetail = (id) => {
    nav(`/joinus/${id}`);
  };
  const { t } = useTranslation();

  const onChangeFilter = (newSelected) => {
    setSelected(newSelected);
  };

  const tabs = [
    { key: "all", title: `${t("joinus.jobs.tabs.tab-one")}` },
    { key: "developer", title: `${t("joinus.jobs.tabs.tab-two")}` },
    { key: "business", title: `${t("joinus.jobs.tabs.tab-three")}` },
    { key: "other", title: `${t("joinus.jobs.tabs.tab-four")}` },
  ];

  const jobs = [
    {
      // type: "developer".工程师 2.产品 3.商务
      type: "developer",
      id: 1,
      title: `${t("joinus.jobs.job-one.title")}`,
      intro: `${t("joinus.jobs.job-one.intro")}`,
      experience: `${t("joinus.jobs.job-one.experience")}`,
    },
    {
      type: "developer",
      id: 2,
      title: `${t("joinus.jobs.job-two.title")}`,
      intro: `${t("joinus.jobs.job-two.intro")}`,
      experience: `${t("joinus.jobs.job-two.experience")}`,
    },
    {
      type: "developer",
      id: 3,
      title: `${t("joinus.jobs.job-three.title")}`,
      intro: `${t("joinus.jobs.job-three.intro")}`,
      experience: `${t("joinus.jobs.job-three.experience")}`,
    },
    {
      type: "developer",
      id: 21,
      title: `${t("joinus.jobs.job-21.title")}`,
      intro: `${t("joinus.jobs.job-21.intro")}`,
      experience: `${t("joinus.jobs.job-21.experience")}`,
    },
    {
      type: "developer",
      id: 4,
      title: `${t("joinus.jobs.job-four.title")}`,
      intro: `${t("joinus.jobs.job-four.intro")}`,
      experience: `${t("joinus.jobs.job-four.experience")}`,
    },
    {
      type: "developer",
      id: 5,
      title: `${t("joinus.jobs.job-five.title")}`,
      intro: `${t("joinus.jobs.job-five.intro")}`,
      experience: `${t("joinus.jobs.job-five.experience")}`,
    },
    {
      type: "developer",
      id: 6,
      title: `${t("joinus.jobs.job-six.title")}`,
      intro: `${t("joinus.jobs.job-six.intro")}`,
      experience: `${t("joinus.jobs.job-six.experience")}`,
    },
    {
      type: "developer",
      id: 7,
      title: `${t("joinus.jobs.job-seven.title")}`,
      intro: `${t("joinus.jobs.job-seven.intro")}`,
      experience: `${t("joinus.jobs.job-seven.experience")}`,
    },
    {
      type: "developer",
      id: 8,
      title: `${t("joinus.jobs.job-eight.title")}`,
      intro: `${t("joinus.jobs.job-eight.intro")}`,
      experience: `${t("joinus.jobs.job-eight.experience")}`,
    },
    {
      type: "business",
      id: 9,
      title: `${t("joinus.jobs.job-nine.title")}`,
      intro: `${t("joinus.jobs.job-nine.intro")}`,
      experience: `${t("joinus.jobs.job-nine.experience")}`,
    },
    {
      type: "business",
      id: 10,
      title: `${t("joinus.jobs.job-ten.title")}`,
      intro: `${t("joinus.jobs.job-ten.intro")}`,
      experience: `${t("joinus.jobs.job-ten.experience")}`,
    },
    {
      type: "business",
      id: 11,
      title: `${t("joinus.jobs.job-11.title")}`,
      intro: `${t("joinus.jobs.job-11.intro")}`,
      experience: `${t("joinus.jobs.job-11.experience")}`,
    },
    {
      type: "business",
      id: 12,
      title: `${t("joinus.jobs.job-12.title")}`,
      intro: `${t("joinus.jobs.job-12.intro")}`,
      experience: `${t("joinus.jobs.job-12.experience")}`,
    },
    {
      type: "business",
      id: 13,
      title: `${t("joinus.jobs.job-13.title")}`,
      intro: `${t("joinus.jobs.job-13.intro")}`,
      experience: `${t("joinus.jobs.job-13.experience")}`,
    },
    {
      type: "business",
      id: 14,
      title: `${t("joinus.jobs.job-14.title")}`,
      intro: `${t("joinus.jobs.job-14.intro")}`,
      experience: `${t("joinus.jobs.job-14.experience")}`,
    },
    {
      type: "business",
      id: 15,
      title: `${t("joinus.jobs.job-15.title")}`,
      intro: `${t("joinus.jobs.job-15.intro")}`,
      experience: `${t("joinus.jobs.job-15.experience")}`,
    },
    {
      type: "business",
      id: 16,
      title: `${t("joinus.jobs.job-16.title")}`,
      intro: `${t("joinus.jobs.job-16.intro")}`,
      experience: `${t("joinus.jobs.job-16.experience")}`,
    },
    {
      type: "business",
      id: 17,
      title: `${t("joinus.jobs.job-17.title")}`,
      intro: `${t("joinus.jobs.job-17.intro")}`,
      experience: `${t("joinus.jobs.job-17.experience")}`,
    },
    {
      type: "other",
      id: 18,
      title: `${t("joinus.jobs.job-18.title")}`,
      intro: `${t("joinus.jobs.job-18.intro")}`,
      experience: `${t("joinus.jobs.job-18.experience")}`,
    },
    // {
    //   type: "other",
    //   id: 19,
    //   title: `${t("joinus.jobs.job-19.title")}`,
    //   intro: `${t("joinus.jobs.job-19.intro")}`,
    //   experience: `${t("joinus.jobs.job-19.experience")}`,
    // },
    {
      type: "other",
      id: 20,
      title: `${t("joinus.jobs.job-20.title")}`,
      intro: `${t("joinus.jobs.job-20.intro")}`,
      experience: `${t("joinus.jobs.job-20.experience")}`,
    },

    {
      type: "other",
      id: 22,
      title: `${t("joinus.jobs.job-22.title")}`,
      intro: `${t("joinus.jobs.job-22.intro")}`,
      experience: `${t("joinus.jobs.job-22.experience")}`,
    },
  ];

  return (
    <div className="joinus-content">
      <section className="joinus-jobs">
        <div className="inner">
          <div className="top">
            <div className="title">{t("joinus.jobs.title")}</div>
            <div className="subtitle">{t("joinus.jobs.subtitle")}</div>
          </div>
          <div className="joinus-tabs">
            {tabs.map((tab) => {
              const cls = classnames({
                "item-tab": true,
                selected: tab.key === selected,
              });
              return (
                <div className={cls} onClick={() => onChangeFilter(tab.key)}>
                  {tab.title}
                </div>
              );
            })}
          </div>
          <div className="content-warp">
            {jobs
              .filter(function (job) {
                if (selected === "all") {
                  return job;
                }
                if (job.type === selected) {
                  return job;
                }
                return false;
              })
              .map((item) => {
                return (
                  <div className="job-card">
                    <div className="card-title">{item.title}</div>
                    <div className="card-content">{item.intro}</div>
                    <div className="card-bottom">
                      <span className="exp">{item.experience}</span>
                      <span
                        className="apply"
                        onClick={() => enterDetail(item.id)}
                      >
                        {t("joinus.jobs.button-apply")}
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
    </div>
  );
};
